
import styled from "styled-components";
import theme from "./../../styles/theme"

export const Pillars = styled.div`
  position: relative;


  div:target {
    scroll-margin-top: 100px;
  }


  .slick-slider{
    display: none;
  }
  @media (max-width:  ${theme.breakpoints.medium}) {
    .slick-slider{
      display: block;
      padding: 0 0 0 20px;
    }
  }

`;

export const PillarsBackgroud = styled.div`
  img {
    height: 750px;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    img{
      height: 600px;
    }
  }
`;



export const PillarsWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  height: 100%;
`;

export const PillarsBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;
  padding-top: 200px;

  @media (max-width:  ${theme.breakpoints.medium}){
    display: none;
  }
`;

export const PillarsCards = styled.div`
  background-color: white;
  width: 230px;
  padding: 50px 25px 20px;
  position: relative;
  transition: all 2s ease;

  div:first-child{
    transition: all 0.3s ease-in-out;
    gap: 10px;
  }



  &:hover{
    div:first-child{
      gap: 50px;

      .TextImgs{
        img{
          transform: scale(1.4);
        }

      }
    }
  }
`;

export const TitlePillar = styled.div`
  color: ${theme.colors.gray};
  font-family: ${theme.fonts.montSerrat};
  font-size: 22px;
  font-style: normal;
  font-weight: ${theme.fontWeights.bold};
  height: 60px;
  line-height: 27px;
  padding-bottom: 10px;
  margin-bottom: 25px;
  text-align: left;
`;

export const SubTitlePillar = styled.div`
  color: ${theme.colors.gray};
  font-family: ${theme.fonts.montSerrat};
  font-size: ${theme.fontSizes.small};
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  text-align: left;

`;
export const PillarsImgs = styled.div`
  display: flex;
  position: absolute;
  align-items: baseline;
  top: -30%;
  left: 50%;
  transform: translateX(-50%);
`;


export const TextImgs = styled.div`
  transition: all 0.2s ease-in-out;

  img{
    transition: all 0.3s ease-in-out;
    width: 75%!important;
    padding-bottom: 15px;
  }
`;

export const IconsCards = styled.div`
  display: flex;

`;


export const PillarsArrowTop = styled.div`
  position: absolute;
  top: -4%;
  left: 48%;

  @media (max-width:  ${theme.breakpoints.medium}){
    top: 0%;
    left: 44%;
  }
`;

export const PillarsArrowBottom = styled.div`
  position: absolute;
  bottom: -10%;
  right: 47%;

  @media (max-width: 1800px){
    right: 46%;
  }

  @media (max-width: 1500px){
    right: 45%;
  }

  @media (max-width: 1300px){
    right: 44.5%;
  }

  @media (max-width:  ${theme.breakpoints.medium}){
    display: none;
  }
`;
